import { render } from "./UsageStats.vue?vue&type=template&id=34190726&scoped=true&ts=true"
import script from "./UsageStats.vue?vue&type=script&lang=ts"
export * from "./UsageStats.vue?vue&type=script&lang=ts"

import "./UsageStats.vue?vue&type=style&index=0&id=34190726&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34190726"]])

export default __exports__